import { render, staticRenderFns } from "./upload-docs-modal.vue?vue&type=template&id=4051d582"
import script from "./upload-docs-modal.vue?vue&type=script&lang=js"
export * from "./upload-docs-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-docs-modal.vue?vue&type=style&index=0&id=4051d582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports